// decodeEntities — un-escape HTML entities for DISPLAY.
//
// Some LitGroup / book / author names were stored HTML-escaped upstream (e.g.
// "Thodkin&#x27;s" instead of "Thodkin's"), so they render with literal entity
// codes in dropdowns and labels. This decodes them at the point of display.
//
// Safe by construction: the decoded string is returned as plain text for React
// to render as a text node — it is NEVER injected as innerHTML downstream. The
// textarea trick only *reads* .value, so no markup in the input can execute.

export function decodeEntities(input) {
  if (typeof input !== 'string' || input.indexOf('&') === -1) return input;
  if (typeof document === 'undefined') return input; // non-DOM guard
  const el = document.createElement('textarea');
  el.innerHTML = input;
  return el.value;
}

export default decodeEntities;
